<template>
  <div class="container">
    <h3>借用</h3>
    <el-form label-position="left" label-width="80px" ref="formLabelAlign">
      <el-form-item label="选择员工">
        <el-select v-model="value5" multiple placeholder="请选择">
          <el-option
            v-for="(item,index) in options"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择领导">
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="(item,index) in options"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="评估时间">
        <el-date-picker
          v-model="chartTimeValue"
          type="daterange"
          unlink-panels
          align="center"
          value-format="timestamp"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="generate">生成评估单</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { formatDate } from "../../common/date";
export default {
  data() {
    return {
      value5: [],
      options: [],
      value: "",
      uid: "",
      chartTimeValue: [Date.now(), Date.now()]
    };
  },
  methods: {
    getinfo() {
      this.$axios({
        url: "/api/user/pcUsers",
        method: "GET"
      })
        .then(res => {
          this.options = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    generate() {
      if (this.value5.length == 0) {
        this.$message({
          message: "请选择员工信息",
          type: "warning"
        });
        return;
      }
      if (this.value == "") {
        this.$message({
          message: "请选择领导信息",
          type: "warning"
        });
        return;
      }
      if (!this.chartTimeValue) {
        this.$message({
          message: "请选择时间",
          type: "warning"
        });
        return;
      }
      this.$axios({
        url: "/api/performance",
        method: "POST",
        data: {
          assessedIds: this.value5,
          assessorId: this.value,
          startDate: formatDate(this.chartTimeValue[0], "yyyy-MM-dd"),
          endDate: formatDate(this.chartTimeValue[1], "yyyy-MM-dd")
        }
      })
        .then(res => {
          if (res.status == 200) {
            this.$message({
              message: "生成成功",
              type: "success"
            });
            this.$router.push({
              path: "./performanceLi",
              query: {
                startDate: this.chartTimeValue[0],
                endDate: this.chartTimeValue[1]
              }
            });
          } else {
            this.$message({
              message: "生成失败",
              type: "warning"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created: function() {
    this.getinfo();
    this.uid = localStorage.uid;
  }
};
</script>

<style scoped>
  .el-button--primary {
    color: #fff;
    background-color:  rgb(60, 110, 169);
    border-color: rgb(60, 110, 169);
  }
  .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #fff;
    background-color: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
  }
  .el-button--primary:focus, .el-button--primary:hover {
    background: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
    color: #fff;
  }
.container {
  padding: 25px;
}

.container h3 {
  font-weight: normal;
  font-size: 16px;
  color: #95b2d4;
  padding: 10px 0px;
  margin-bottom: 15px;
}

.container h4 {
  font-weight: normal;
  font-size: 16px;
  color: red;
  padding: 10px 0px;
  margin-top: 20px;
  margin-bottom: 15px;
}

.drugs {
  width: 100%;
  height: auto;
}

.operation {
  margin-top: 30px;
  float: right;
}

.preserve {
  margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// generate.vue?7dda3784